import { render, staticRenderFns } from "./OfertaForm.vue?vue&type=template&id=f4b37496"
import script from "./OfertaForm.vue?vue&type=script&lang=js"
export * from "./OfertaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports